/** @jsxImportSource @emotion/react */

import { css, Dialog, DialogTitle } from "@mui/material";
import { PALETTE } from "styles/base/variables";

export type TermType = "privacy" | "consignment" | "service";

interface UserDialogProps {
  isOpen: boolean;
  setIsOpen: (value: TermType | null) => void;
  termType: TermType | null;
}

function TermDialog({ isOpen, setIsOpen, termType }: UserDialogProps) {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(null)}>
      <DialogTitle
        css={css`
          background-color: ${PALETTE.background};
        `}
      >
        약관 확인
      </DialogTitle>
      <div
        css={css`
          padding: 20px;
        `}
        dangerouslySetInnerHTML={{ __html: TermPage({ termType }) }}
      />
    </Dialog>
  );
}

const TermPage = ({ termType }: { termType: TermType | null }): string => {
  switch (termType) {
    case "privacy":
      return "<iframe src='/term/20230421/priv_info_ag_tax.html' width='500px' height='500px' />";
    case "consignment":
      return "<iframe src='/term/20220913/priv_info_con_ag.html' width='500px' height='500px' />";
    case "service":
      return "<iframe src='/term/20230421/srv_ag_tax.html' width='500px' height='500px' />";
    default:
      return "<iframe src='/term/20230421/srv_ag_tax.html' width='500px' height='500px' />";
  }
};

export default TermDialog;
